"use client";

import Image from "next/image";
import { ContainerGlob } from "../../../componentsGLob/ContainerGlob";
import { DecorativeElements } from "../../../componentsGLob/Decorative/decorative-elements";
import { HERO_DECORATIVES } from "./home-decorative.config";
import { useTranslation } from "react-i18next";

const gradientText =
  "text-transparent bg-clip-text bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500";

export const HeroSection = () => {
  const { t } = useTranslation("heroCoworking");

  return (
    <section
      id="home"
      className="relative w-full flex items-start justify-center pt-[5vh] pb-12 bg-white overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <DecorativeElements elements={HERO_DECORATIVES} isEnabled={true} />
      </div>

      <ContainerGlob className="relative z-10">
        <div className="flex flex-col items-center text-center gap-5">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-gray-900 leading-tight">
            {t("titlePrefix")} <span className={gradientText}>Beehive</span>
          </h1>
          <div className="max-w-2xl space-y-4">
            <p className="text-lg md:text-xl text-gray-600 leading-relaxed">
              {t("paragraph1")}
            </p>
            <p className="text-lg md:text-xl text-gray-600 leading-relaxed">
              {t("paragraph2")}
            </p>
          </div>
          <div className="mt-2">
            <Image
              src="/group.jpg"
              alt={t("imageAlt")}
              width={700}
              height={600}
              className="rounded-xl shadow-xl object-cover"
              priority
            />
          </div>
        </div>
      </ContainerGlob>
    </section>
  );
};
